import request from '../../library/request';
import setGlobalState from '../setGlobalState';
import {getState} from '../store.type';

const getEid = () => getState().event.eid;

export const getPromotionSummary = async () => {
    const res = await request('promotionSummary.event.getPromotionSummary', 'get', `/event/${getEid()}/promotionSummary`);
    if(res && typeof res === 'object')
        setGlobalState('promotionSummary.event.stats', res);
};
